import { ROUTES } from './classroomRoutes';

export function buildPortalAccessUrl(origin = window.location.origin) {
  return `${origin}${ROUTES.CLASSROOM_PORTAL}`;
}

export function resolvePortalAccessUrl() {
  return buildPortalAccessUrl();
}

export function getPortalLoginPath() {
  return ROUTES.CLASSROOM_PORTAL;
}
